<template>
  <div class="home-view">
    <h2>欢迎来到实用工具箱</h2>
    <p>点击左侧菜单可以切换不同的内容页面。</p>
  </div>
</template>

<script>
export default {
  name: 'IndexView'
}
</script>

<style scoped>
.home-view {
  background-color: white;
  padding: 2rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>